import styled from 'styled-components';

export default styled.input`
  width: 85%;
  padding: 1em;
  font-size: 1em;
  background-color: rgb(0, 0, 0, 0);
`;
